// const env = process.ENVIRONMENT;

export const LOCAL_STORAGE_KEYS = {
  // Redux Stores too
  BROWSER_ID: "newsie-browser-id",
  SESSION_TOKEN: "newsie-session-token",
  AUTH: "auth",
  GAME: "game",
  MODAL: "modal",
  STATE: "state",
  CLIENT_PROFILE: "client-profile",
  META: "meta",
  SELECTED_NEWSIE: "selected-newsie",
  USER_PERFORMANCE: "user-performance",
  PUBLIC_PUZZLE: "public-puzzle",
  PUBLIC_STATE: "public-state",
  PUZZLE: "puzzle",
};

export const GAMES = {
  NEWSIE: "newsie",
  WORDSEARCH: "wordsearch",
  CROSSWORD: "crossword",
  QUIZ: "quiz",
};

export const GAMES_LABELS = {
  NEWSIE: "Newsie",
  WORDSEARCH: "Wordsearch",
  CROSSWORD: "Crosssord",
  QUIZ: "Quiz",
};

export const REQUESTS = {
  SUBMIT_PUZZLE_TEXT: "submitPuzzleText",
  SAVE_PUZZLE: "savePuzzle",
  DELETE_PUZZLE: "deletePuzzle",
  EMAIL_PASSWORD_LOGIN: "emailPasswordLogin",
  VERIFY_ACCOUNT_EMAIL: "verifyAccountEmail",
  GET_PUZZLE: 'getPuzzle',
  DELETE_PROFILE: 'deleteProfile',
  GET_PROFILE: 'getProfile',
  VERIFY_EMAIL: 'verifyEmail',
};

export const SERVER_URL = "https://dmdbhtya6u.us-west-2.awsapprunner.com";
